import { LeaderboardData } from "lib/types/LeaderboardTypes";
import { asyncActionCreators } from "../../lib/util/ReduxUtils";
import { ScopeInfo } from "../../lib/types/MiscTypes";

import * as Api from "../../Api";

export const getGroupLeaderboards = asyncActionCreators<
	ScopeInfo & { rootGroup?: string },
	{
		[groupName: string]: {
			active: LeaderboardData[];
			complete: LeaderboardData[];
		};
	}
>(
	"[LEADERBOARDS] GET_GROUP_LEADERBOARDS",
	async (action, dispatch, getState) => {
		const { fleetId, group } = action.payload;
		const currentLeaderboards = getState().Leaderboards.leaderboards.value;
		const groupKey = group ? `${fleetId}/${group}` : fleetId;
		const existingLeaderboards = currentLeaderboards?.[groupKey];

		if (existingLeaderboards || !fleetId) {
			return currentLeaderboards;
		}

		const result = await Api.fetchGroupLeaderboards.submit({
			query: { group: group || undefined },
			params: { fleetId },
		});

		return {
			[groupKey]: {
				active: result.data
					.map((leaderboard: LeaderboardData, index: number) => {
						if (leaderboard.active) {
							return { ...leaderboard, index: index + 1 };
						}

						return null;
					})
					.filter(Boolean),
				complete: result.data
					.map((leaderboard: LeaderboardData, index: number) => {
						if (!leaderboard.active) {
							return { ...leaderboard, index: index + 1 };
						}

						return null;
					})
					.filter(Boolean),
			},
		};
	},
);
